// По ТЗ 10.09.2026: API для 5 табов страницы службы.
import { http } from '@/api/http'

// -------- Остатки / Отчёт / В пользовании --------

export async function getServiceStock(code, asOf) {
  const params = asOf ? { as_of: asOf } : {}
  const { data } = await http.get(`wms/services/${code}/stock/`, { params })
  return data // { items: [...], warehouse_count }
}

export async function getServiceReport(code, from, to) {
  const { data } = await http.get(`wms/services/${code}/report/`, { params: { from, to } })
  return data // { items: [...], from, to }
}

export async function getServiceIssued(code, statusFilter = 'on_hands') {
  const { data } = await http.get(`wms/services/${code}/issued/`, { params: { status: statusFilter } })
  return Array.isArray(data) ? data : (data?.results || [])
}

// -------- Операции (с фильтром по службе) --------

export async function listOperationsByService(code, kind, params = {}) {
  // kind = 'add' | 'expense' — маппинг с UI
  const opType = kind === 'receipt' ? 'add' : (kind === 'expense' ? 'expense' : kind)
  const { data } = await http.get('wms/operations/', {
    params: { service: code, operation_type: opType, page_size: 100, ...params },
  })
  return data?.results || data || []
}

export async function createOperation(payload) {
  const { data } = await http.post('wms/operations/', payload)
  return data
}

// -------- Выдача в пользование --------

export async function createIssue(payload) {
  const { data } = await http.post('wms/issues/', payload)
  return data
}

export async function returnIssue(id, note = '') {
  const { data } = await http.post(`wms/issues/${id}/return/`, { note })
  return data
}

export async function writeOffIssue(id, payload = {}) {
  const { data } = await http.post(`wms/issues/${id}/write-off/`, payload)
  return data
}

// -------- Номенклатура / Склад для селектов --------

export async function listNomenclature() {
  const { data } = await http.get('wms/nomenclatures/', { params: { page_size: 200 } })
  return data?.results || data || []
}

export async function listWarehousesByService(code) {
  // По ТЗ 10.09.2026: серверный фильтр по коду службы. Раньше здесь был
  // локальный filter(w => w.service.code === code), который не срабатывал,
  // потому что бэк отдавал service как id (число), а не объект.
  const params = { page_size: 100 }
  if (code) params.service = code
  const { data } = await http.get('wms/warehouses/', { params })
  return data?.results || data || []
}

// -------- ГСМ / ПФС специфика --------

export async function createTripSheet(payload) {
  const { data } = await http.post('wms/trip-sheets/', payload)
  return data
}
export async function approveTripSheet(id, payload) {
  const { data } = await http.post(`wms/trip-sheets/${id}/approve/`, payload)
  return data
}
export async function generateRation(payload) {
  const { data } = await http.post('wms/rations/generate/', payload)
  return data
}
export async function listIssueNorms(serviceId) {
  const { data } = await http.get('wms/issue-norms/', { params: { service: serviceId, page_size: 100 } })
  return data?.results || data || []
}
